/* eslint-disable */ import { assertBoolean, assertNumber, assertString, attributeSelectionComponent, attributeSwitchComponent, genericDimensionComponent, memoEval, textValueComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachAdminComponent } from '../admin-implementation.js';
import { Finish, RawMaterial } from '../model/index.js';
export const customMaterialComponents = [
    attachAdminComponent.withComponent(textValueComponent, 'name', true).withEntity('CustomMaterial').attach(memoEval((self)=>[
            self.name
        ], (name)=>({
            value: name
        })), (state)=>{
        assertString(state.value);
        return {
            name: state.value
        };
    }),
    attachAdminComponent.withComponent(textValueComponent, 'code', true).withEntity('CustomMaterial').attach(memoEval((self)=>[
            self.code
        ], (code)=>({
            value: code
        })), (state)=>{
        assertString(state.value);
        return {
            code: state.value
        };
    }),
    attachAdminComponent.withComponent(genericDimensionComponent, 'length', true).withEntity('CustomMaterial').attach(memoEval((self)=>[
            self.length
        ], (length)=>({
            value: length,
            min: 100,
            max: 10000,
            unit: 'mm'
        })), (state)=>{
        assertNumber(state.value);
        return {
            length: state.value
        };
    }),
    attachAdminComponent.withComponent(genericDimensionComponent, 'width', true).withEntity('CustomMaterial').attach(memoEval((self)=>[
            self.width
        ], (width)=>({
            value: width,
            min: 100,
            max: 10000,
            unit: 'mm'
        })), (state)=>{
        assertNumber(state.value);
        return {
            width: state.value
        };
    }),
    attachAdminComponent.withComponent(genericDimensionComponent, 'thickness', true).withEntity('CustomMaterial').attach(memoEval((self)=>[
            self.thickness
        ], (thickness)=>({
            value: thickness,
            min: 0.1,
            max: 10,
            unit: 'mm'
        })), (state)=>{
        assertNumber(state.value);
        return {
            thickness: state.value
        };
    }),
    attachAdminComponent.withComponent(attributeSelectionComponent, 'rawMaterial', true).withEntity('CustomMaterial').attach(memoEval((self)=>[
            self.rawMaterial,
            self.$rawMaterialOptions
        ], (rawMaterial, $rawMaterialOptions)=>({
            value: rawMaterial,
            options: $rawMaterialOptions
        })), (state)=>{
        RawMaterial.assert(state.value);
        return {
            rawMaterial: state.value
        };
    }),
    attachAdminComponent.withComponent(attributeSelectionComponent, 'finish', true).withEntity('CustomMaterial').attach(memoEval((self)=>[
            self.finish,
            self.$finishOptions
        ], (finish, $finishOptions)=>({
            value: finish,
            options: $finishOptions
        })), (state)=>{
        Finish.assert(state.value);
        return {
            finish: state.value
        };
    }),
    attachAdminComponent.withComponent(attributeSwitchComponent, 'visible', true).withEntity('CustomMaterial').attach(memoEval((self)=>[
            self.visible
        ], (visible)=>({
            value: visible
        })), (state)=>{
        assertBoolean(state.value);
        return {
            visible: state.value
        };
    }),
    attachAdminComponent.withComponent(attributeSwitchComponent, 'standard', true).withEntity('CustomMaterial').attach(memoEval((self)=>[
            self.standard
        ], (standard)=>({
            value: standard
        })), (state)=>{
        assertBoolean(state.value);
        return {
            standard: state.value
        };
    }),
    attachAdminComponent.withComponent(attributeSwitchComponent, 'powderCoatingEnabled', true).withEntity('CustomMaterial').attach(memoEval((self)=>[
            self.powderCoatingEnabled
        ], (powderCoatingEnabled)=>({
            value: powderCoatingEnabled
        })), (state)=>{
        assertBoolean(state.value);
        return {
            powderCoatingEnabled: state.value
        };
    })
];

//# sourceMappingURL=custom-material.js.map